import {
  FormControl,
  FormControlProps,
  FormLabel,
  Menu,
  MenuButton,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
} from '@chakra-ui/react';
import * as React from 'react';

import { SelectButton } from '@/components/SelectButton';
import { MembershipStatus } from '@/graphql-types/globalTypes';
import { useMemberManagement } from '@/hooks/useMemberManagement';
import { READABLE_MEMBERSHIP_STATUS } from '@/utilities';

export const MembershipStatusFilter: React.FC<
  {
    value: MembershipStatus[];
    onChange: (value: MembershipStatus[]) => void;
  } & Omit<FormControlProps, 'value' | 'onChange'>
> = ({ value, onChange, ...props }) => {
  const memberManagement = useMemberManagement();
  return (
    <FormControl {...props}>
      <FormLabel textStyle="detailStrong" whiteSpace="nowrap">
        {memberManagement.isActive ? 'Membership' : 'Member'} Status
      </FormLabel>
      <Menu closeOnSelect={false}>
        <MenuButton as={SelectButton} variant="menu">
          {value.length === 0
            ? 'All'
            : value.length === 1
            ? READABLE_MEMBERSHIP_STATUS[value[0]]
            : `(${value.length}) Selected`}
        </MenuButton>
        <MenuList>
          <MenuOptionGroup value={value} onChange={onChange} type="checkbox">
            <MenuItemOption value={MembershipStatus.MEMBER}>
              {READABLE_MEMBERSHIP_STATUS[MembershipStatus.MEMBER]}
            </MenuItemOption>
            {memberManagement.isActive && (
              <MenuItemOption value={MembershipStatus.LAPSED}>
                {READABLE_MEMBERSHIP_STATUS[MembershipStatus.LAPSED]}
              </MenuItemOption>
            )}
            <MenuItemOption value={MembershipStatus.NOT_A_MEMBER}>
              {READABLE_MEMBERSHIP_STATUS[MembershipStatus.NOT_A_MEMBER]}
            </MenuItemOption>
          </MenuOptionGroup>
        </MenuList>
      </Menu>
    </FormControl>
  );
};
